// features/tableSelection/tableSelectionSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TableSelectionState {
  selectedItems: any[];
  selectedModule: string | null;
}

const initialState: TableSelectionState = {
  selectedItems: [],
  selectedModule: null,
};

const tableSlice = createSlice({
  name: 'table',
  initialState,
  reducers: {
    setSelectedItems: (state, action: PayloadAction<{items: any[], module: string}>) => {
      state.selectedItems = action.payload.items;
      state.selectedModule = action.payload.module;
    },
    clearSelectedItems: (state) => {
      state.selectedItems = [];
      state.selectedModule = null;
    },
  },
});

export const { setSelectedItems, clearSelectedItems } = tableSlice.actions;
export default tableSlice.reducer;